export class RemissionDetailFromOrderModel {
    orderDetailId: number = 0;
    remissionDetailId: number = 0;
    remissionId: number = 0;
    articleId: number = 0;
    storeId: number = 0;
    quantityFinal: number = 0;
    quantityPending: number = 0;
    quantityReserved: number = 0;
    stock: number = 0;
    quantity: number = 0;
}
